<template>
  <div class="content">
    <controlbar
      :dispItems="places"
      @input-event="setPlaces"
      @list-reload="reload"
    >
    </controlbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="table_contents">
            <label class="user_id_label">
              {{ userIdLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="location_name_label">
              {{ userNameLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="phone_number_label">
              {{ phoneNumberLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="location_address_label">
              {{ locationAddressLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispPlace in places"
            :key="dispPlace.userId"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="dispPlace.checked"
                @click="checkedAction(dispPlace)"
              />
            </th>
            <td class="table_contents" @click="setActive(dispPlace)">
              <label class="user_id">
                {{ dispPlace.userId }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispPlace)">
              <label class="place_name">
                {{ dispPlace.userName }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispPlace)">
              <label class="phone_number">
                {{ dispPlace.phoneNumber }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispPlace)">
              <label class="location_address">
                {{ dispPlace.locationAddress }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setPlaces(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import Pagination from 'vue-pagination-2'

export default {
  data() {
    return {
      userIdLabel: '拠点ID',
      userNameLabel: '拠点名',
      phoneNumberLabel: '電話番号',
      locationAddressLabel: '住所',
      showFalseModal: false,
      showCompleteModal: false,
      windowHeight: '',
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0,
      prevSearchWord: ''
    }
  },
  computed: {
    places() {
      return this.$store.state.places.locations
    },
    total() {
      if ((this.page - 1) * this.pageSize <= this.$store.state.places.total) {
        return this.$store.state.places.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (this.page - 1) * this.pageSize >= this.$store.state.places.total
    },
    lastPage() {
      const last = Math.ceil(this.$store.state.places.total / this.pageSize)
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('places/clearSelectedLocationList')
    this.$store.state.prevPageNo = 0
    this.$store.state.prevSearchWord = ''
    this.setPlaces(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    falseModalWindow,
    loadingModalWindow,
    Pagination
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.places.length; i++) {
        this.places[i].checked = this.checked
      }
      this.$store.dispatch('places/updateSelectedLocationList', this.places)
    },
    checkedAction(place) {
      place.checked = !place.checked
      this.$store.dispatch('places/updateSelectedLocationList', [place])
    },
    close(e) {
      this.showFalseModal = false
      this.showCompleteModal = false
    },
    async reload() {
      this.$store.dispatch('places/clearSelectedLocationList')
      await this.setPlaces(
        this.$store.state.prevPageNo,
        this.$store.state.prevSearchWord
      )
    },
    async setPlaces(pageNo, searchWord = null) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        searchWord =
          searchWord === null ? this.$store.state.prevSearchWord : searchWord
        await this.$store.dispatch('places/setLocations', {
          pageNo: pageNo,
          searchWord: searchWord
        })
        if (pageNo > 0) {
          if (this.isOverPage) {
            this.page = this.lastPage
          } else {
            this.page = pageNo + 1
          }
        } else {
          this.page = 1
        }
        this.$store.state.prevPageNo = pageNo
        this.$store.state.prevSearchWord = searchWord
        this.checked = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_170001
        let eventType = 3
        let reason = 'MSGCRC0027 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0027.name +
            this.errorMsg.MSGCRC0027.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('places/setDetailLocation', payload)
        if (location.pathname !== '/places/detail') {
          this.$router.push('../places/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_170002
        let eventType = 3
        let reason = 'MSGCRC0028 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0028.name +
            this.errorMsg.MSGCRC0028.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scoped>
td {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/places/placesList.vue